
import { Component, Vue, Prop } from "vue-property-decorator";
import { TreeNode } from "@/types/tree";
import {
  calculateElementPositionOnCanvas,
  listenForPositionChangesAndGetNewPosition,
  ElementPositionOnCanvas,
  getWrapperStyle,
  getOutlineStyle
} from "@/futurelayer/canvas/canvas-controls/element-positioning";
import { getFutureLayerElementBehavior } from "@/futurelayer/canvas/element-behavior/element-behavior";
import { SECTION_SLUG } from "@/lib/elements/constants";
import AddAnotherSectionButton from "./AddAnotherSectionButton.vue";
import { uiStore } from "@/store/store-accessor";

@Component({
  components: {
    AddAnotherSectionButton
  }
})
export default class FutureLayerHoveredElementOutline extends Vue {
  @Prop()
  element!: TreeNode;

  elementPositionOnCanvas: ElementPositionOnCanvas = false;
  cleanupListeners: () => void = () => {};

  mounted() {
    this.elementPositionOnCanvas = calculateElementPositionOnCanvas(this.element);

    this.cleanupListeners = listenForPositionChangesAndGetNewPosition(
      this.element,
      (newPosition: ElementPositionOnCanvas) => {
        this.elementPositionOnCanvas = newPosition;
      }
    );
  }

  beforeDestroy() {
    this.cleanupListeners();
  }

  get canActivate() {
    return getFutureLayerElementBehavior(this.element.data.type).canActivate;
  }

  get cssStyleForWrapper(): Record<string,string> {
    if (!this.canActivate) {
      return { display: "none" };
    }
    return getWrapperStyle(this.elementPositionOnCanvas);
  }

  get cssStyleForOutline(): Record<string,string> {
    if (!this.canActivate) {
      return { display: "none" };
    }
    return getOutlineStyle(this.elementPositionOnCanvas);
  }

  get isSection(): boolean {
    return this.element.data.type === SECTION_SLUG;
  }

  get isInlineEditing(): boolean {
    return uiStore.isInlineEditing;
  }
}
